export const SHOW_HIDE_SNACKBAR = "SHOW_HIDE_SNACKBAR";
